import gql from 'graphql-tag';

export const getMyCurrentStreak = gql`
  query mpGetMyStreak {
    mpMyCurrentStreak {
      streak
      checkIn {
        dayOfWeek
        checked
      }
    }
  }
`;

export const getMyWeeklyLearningHour = gql`
  query mpGetMyWeeklyLearningHours {
    mpMyWeeklyLearningHour {
      startDate
      progress {
        type
        amount
      }
      targetHoursPerWeek
      durationByCategory {
        category
        duration
      }
    }
  }
`;

export const getMPMyGoalStatus = gql`
  query mpGetMyGoalStatus {
    mpMyGoalStatus {
      status
    }
  }
`;

export const getMPMyGoals = gql`
  query mpGetMyGoals {
    mpMyGoals {
      id
    }
  }
`;

export const getMyCompletedBadges = gql`
  query mpGetMyCompletedBadges {
    mpMyCompletedBadges {
      name
      completed {
        startDate
        endDate
      }
    }
  }
`;

export const getMPMyLatestLearningProgressUpdatedAt = gql`
  query mpGetMyLatestLearningProgressUpdatedAt {
    mpLatestDailyProgressUpdatedAt
  }
`;

export const getMPWeeklyLearningProgressWithCapWorkload = gql`
  query mpGetWeeklyLearningProgressWithCapWorkload($startDate: DateTime!, $endDate: DateTime!) {
    mpGetWeeklyLearningProgress(startDate: $startDate, endDate: $endDate) {
      subjectProgresses {
        date
        subject {
          name
        }
        duration
      }
    }
    mpGetMyStudentSemesters(startDate: $startDate, endDate: $endDate) {
      myStudentSemesters {
        id
        userId
        startDate
        endDate
        actualStartDate
        weekdayCapWorkload
        weekendCapWorkload
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
`;

export const getMPMyProgressTracker = gql`
  query mpGetMyProgressTracker($date: DateTime!, $option: MPProgressTrackerOption) {
    mpMyProgressTracker(date: $date, option: $option) {
      startDate
      endDate
      studentSemester {
        id
        userId
        startDate
        endDate
        actualStartDate
        weekdayCapWorkload
        weekendCapWorkload
      }
      productProgresses {
        product {
          id
          userId
          productId
          type
          subject {
            id
            name
          }
          product {
            id
            name
            category
            academicYear
            duration
            type
          }
          startDate
          endDate
          updatedAt
          duration
          totalDuration
          metadata {
            isMigrated
            isSplitted
          }
        }
        progress {
          percentComplete
          totalDuration
        }
        hasProduct
      }
    }
  }
`;

export const MYPATH_USER_STATUS = {
  NON_MYPATH_USER: 'NON_MYPATH_USER',
  TCAS_USER: 'TCAS_USER',
  MYPATH_USER: 'MYPATH_USER',
};
